import { Tabs } from "baseui/tabs-motion";
import type { ReactNode } from "react";
import * as React from "react";

export const DocsTabs = ({ activeTab = 0, children }: { activeTab: number; children: ReactNode }) => {
  const [activeKey, setActiveKey] = React.useState(activeTab?.toString() || "0");

  React.useEffect(() => {
    setActiveKey(activeTab.toString());
  }, [activeTab]);

  return (
    <Tabs
      activeKey={activeKey}
      onChange={({ activeKey }) => {
        setActiveKey(activeKey.toString());
      }}
      activateOnFocus
      renderAll={typeof window == "undefined"}
    >
      {children}
    </Tabs>
  );
};
